module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("经办人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.userPeopleName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.applyDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("经办部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.userDepartName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.jibie))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("差旅信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("出差人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.outPeopleName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所属部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.tripDepartment))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("同行人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.togetherName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("出差事由")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.tripRemark))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("起止时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.tripDetails))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所属业务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.businessName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("出差审批表")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.businessTripName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("责任中心")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.centerDepartmentName))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("费用信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("费用名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.name))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("单据编号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.recCode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("是否用于抵扣费用报销（不计入成本）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.isDeduction))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("费用明细")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-button', {
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showImg(1)
      }
    }
  }, [_vm._v("查看")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("费用合计（元）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.total1))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("费用合计大写")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.total2))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("预借差旅费（元）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.willTrivalMoney))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("应付费用（元）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.shouldPay))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("收款人信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款人/单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payUnitName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款银行")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.bank))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款账号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.bankAccount))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("支付状态")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payStatus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("支付日期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.payDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.remark))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("财务处理信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("记账单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.recordUnitName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payType))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("付款银行")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.faccountName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("付款账户")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.faccountNo))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0489c326","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/finance/expense.vue
// module id = v0WV
// module chunks = 1